import { useMemo } from "react";

import { 
  createIntFormatter,
  currencyFormatter,
  textFormatter 
} from "../../../../utils/formatter/formatter";

import { AssortmentFinancialTable, BrandMultiSelect } from "./components/index";

import { AssortmentSelect } from "../shared/index";

export const FinancialSection = ({ actions, ctx, uiState }) => {

  const { setSelectedBrands, setFinancialSeason } = actions || {};

  const { 
    financialBrands,
    tableData,
    columns,
    financialSeasonOptions
  } = ctx;

  const { selectedBrands, financialSeason } = uiState;

  const options = useMemo(() => {
    return financialBrands.map(brand => brand.name)
  }, [financialBrands]);

  const topIndexes = useMemo(() => {
    const data = tableData ?? [];
    const intFormatter = createIntFormatter();
    return [
      {
        icon: "📦",
        label: textFormatter("Produtos no Mix"),
        value: intFormatter.format(data.reduce((acc, brand) => acc + (brand.mixQty ?? 0), 0)),
      },
      {
        icon: "💰",
        label: textFormatter("Faturamento Total"),
        value: currencyFormatter.format(data.reduce((acc, brand) => acc + (brand.revenue ?? 0), 0)),
      },
      {
        icon: "📈",
        label: textFormatter("Lucro Real"),
        value: currencyFormatter.format(data.reduce((acc, brand) => acc + (brand.profit ?? 0), 0)),
      },
      {
        icon: "👕",
        label: textFormatter("Peças Vendidas"),
        value: intFormatter.format(data.reduce((acc, brand) => acc + (brand.unitsSold ?? 0), 0)),
      },
    ];
  }, [tableData]);

  return (
    <div style={{ flex: 1, minHeight: 0, overflowY: "auto", display: "flex", flexDirection: "column", gap: 12 }}>
      <section 
        style={{ 
          backgroundColor: "#fff", 
          border: "1px solid #e5e5e5",
          borderRadius: "12px", 
          boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
          padding: "16px 20px", 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "space-between", 
          flexShrink: 0 }}>
        <div>
          <div style={{ fontSize: "16px", fontWeight: "700", color: "#1a1a1a" }}>
            Análise Financeira da Coleção
          </div>

          <div style={{ fontSize: "12px", color: "#aaa", marginTop: 2 }}>
            Visão consolidada de performance financeira por marca e tipo de produto
          </div>
        </div>

        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <BrandMultiSelect
            actions={{ onChange: setSelectedBrands }}
            ctx={{ selected: selectedBrands, options: options }}/>
          
          <AssortmentSelect 
            label=""
            value={financialSeason}
            onChange={setFinancialSeason}
            options={financialSeasonOptions}
          />
        </div>
      </section>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, flexShrink: 0 }}>
        {topIndexes.map(idx => (
          <section 
            style={{
              backgroundColor: "#fff", 
              border: "1px solid #e5e5e5",
              borderRadius: "12px", 
              boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
              padding: "16px 20px"
            }}
            key={idx.label}>
            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
              <span style={{ fontSize: "16px" }}>{idx.icon}</span>
              <span style={{ fontSize: "11px", fontWeight: "500", color: "#aaa" }}>{idx.label}</span>
            </div>
            <div style={{ fontSize: "19px", fontWeight: "700", color: "#1a1a1a" }}>{idx.value}</div>
          </section>
        ))}
      </div>

      <section
        style={{
          backgroundColor: "#fff", 
          border: "1px solid #e5e5e5",
          borderRadius: "12px", 
          boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
        }}>
        <AssortmentFinancialTable ctx={{ tableData: tableData, columns: columns }}/>
      </section>
    </div>
  );
};